module.exports = __webpack_public_path__ + "static/media/logo.f46dff22.svg";